import { Box } from "@mui/system"
import './components.css'
import header from '../../assets/receptheader.png'
import footer from '../../assets/receptfooter.png'

function Reciept(props) {
    let { model } = props
    console.log(model)
    return <>
        <Box >
            <img width="100%" src={header} alt='' />
            <Box className='p-2'>
                <table>
                    <tr>
                        <th>Invoice # </th>
                        <td>:{model.orderNo}</td>
                    </tr>
                    <tr>
                        <th>Customer Name </th><td>:</td>
                    </tr>
                    <tr>
                        <th>Order Date </th><td>:</td>
                    </tr>
                </table>
            </Box>
            <img width="100%" src={footer} alt='' />
        </Box>
    </>
}
export default Reciept